import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddVideo from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import DaVideoPopup from '../../../extensions/extension-video/components/DaVideoPopup';
import { isExtensionInstalled } from '../../utils/tiptap';
import EditorIconButton from '../_partials/EditorIconButton';
export const useVideoButton = (editor)=>{
    const [isModalShown, setIsModalShown] = useState(false);
    const openModal = useCallback(()=>setIsModalShown(true), []);
    const closeModal = useCallback(()=>setIsModalShown(false), []);
    const handleSubmit = useCallback((inputValue)=>{
        if (!editor) {
            return;
        }
        editor.chain().insertContent({
            type: 'da-video',
            attrs: {
                src: inputValue
            }
        }).focus().run();
        closeModal();
    }, [
        editor,
        closeModal
    ]);
    return {
        isModalShown,
        openModal,
        closeModal,
        handleSubmit
    };
};
const Video = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    const { isModalShown, openModal, closeModal, handleSubmit } = useVideoButton(editor);
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'daVideo')) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditorIconButton, {
        icon: AddVideo,
        onClick: openModal,
        tooltipText: t('ext.video.editorToolbar.button.tooltip')
    }), isModalShown && /*#__PURE__*/ React.createElement(DaVideoPopup, {
        onSubmit: handleSubmit,
        onCancel: closeModal
    }));
};
Video.displayName = 'Video';
export default Video;

//# sourceMappingURL=Video.js.map